import { __awaiter } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import CustomerApi from '../../../api/customer/CustomerApi';
import { getIn, useFormikContext } from 'formik';
import { useEffect, useState } from 'react';
import { RegistrationField } from './RegistrationField';
import { useAemConfig } from '@as-react/common-components';
import { sortAlphabetically } from '@as-react/common-utils';
import { FormFieldType, InputState, Select, useIsMounted } from '@as/cotopaxi';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { useTranslation } from 'react-i18next';
import { getCountryByFictiveWebShop } from '../../../util/CountryUtil';
const countryFieldName = 'address.idCountry';
export const RegistrationCountrySelector = ({ setActiveCountry, }) => {
    const [countries, setCountries] = useState([]);
    const [customerCountries, setCustomerCountries] = useState([]);
    const { t } = useTranslation(I18N_NAMESPACES.account);
    const isMounted = useIsMounted();
    const { defaultRequestParams, servicesEndpoint, lang, fictiveWebShop } = useAemConfig();
    const defaultCountryCode = getCountryByFictiveWebShop(fictiveWebShop);
    const { errors, touched, values, setFieldValue } = useFormikContext();
    useEffect(() => {
        const getCountriesFromApi = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const response = yield CustomerApi.getCountries(servicesEndpoint, defaultRequestParams);
                const mappedCountries = sortAlphabetically(response.map(country => ({
                    value: country.idCountry,
                    label: country.countryDescriptionTranslations[lang.toUpperCase()],
                })), 'label');
                if (isMounted()) {
                    setCountries(response);
                    setCustomerCountries(mappedCountries);
                }
            }
            catch (_a) { }
        });
        getCountriesFromApi();
    }, [isMounted]);
    useEffect(() => {
        const countryValue = getIn(values, countryFieldName);
        if (!defaultCountryCode || !!countryValue || !customerCountries) {
            return;
        }
        const countryByCode = countries.find(country => country.countryCode === defaultCountryCode.toUpperCase());
        setFieldValue(countryFieldName, countryByCode === null || countryByCode === void 0 ? void 0 : countryByCode.idCountry);
    }, [values, countries, customerCountries, defaultCountryCode]);
    useEffect(() => {
        const countryValue = getIn(values, countryFieldName);
        if (!countryValue || !countries) {
            return;
        }
        const countryById = countries.find(country => country.idCountry === parseInt(countryValue, 10));
        countryById && setActiveCountry(countryById);
    }, [values, countries]);
    return (_jsx(RegistrationField, { label: t('account.details.country'), placeholder: t('account.details.country.placeholder'), name: countryFieldName, id: "country", state: errors.country && touched.country && InputState.ERROR, componentType: FormFieldType.SELECT, Component: Select, fullWidth: true, options: customerCountries, dataQA: "country" }));
};
